import { render } from "./zip.vue?vue&type=template&id=6884ee57&ts=true"
import script from "./zip.vue?vue&type=script&lang=ts"
export * from "./zip.vue?vue&type=script&lang=ts"

import "./zip.vue?vue&type=style&index=0&id=6884ee57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__